export default function Header() {
    return (
      <header className="w-full bg-orange-500 text-white p-4 flex justify-center items-center shadow-md fixed top-0 left-0 z-50">
        <h1 className="text-2xl font-bold">Word & Token Code Converter</h1>
      </header>
    );
  }
  